import React from 'react';
import Experiences from '../components/Experiences';

const ExperiencesPage = () => {
  return <Experiences />;
};

export default ExperiencesPage;
